import React from 'react';
import { useHistory } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import * as UI from 'UI';
import { withGlobalStateUtils } from 'utils/withGlobalStateUtils';
import * as SC from './UserMangement.sc';
import { useUserManagement } from './useUserManagement';

export const UserManagement = withGlobalStateUtils(({ error }) => {
  const { push } = useHistory();
  const {
    columns,
    rows,
    search,
    handleSearchChange,
    handleSearchCancel,
    sortModel,
    setSortModel,
    handleSelectionChange,
    isUpdating,
    openUserEdit,
  } = useUserManagement({ push });

  return (
    <SC.Container>
      <UI.ErrorBox text={error} width="calc(100% - 40px)" />
      <SC.Header>
        <h3>User Management</h3>
        <UI.GridSearchField
          search={search}
          handleSearchChange={handleSearchChange}
          handleSearchCancel={handleSearchCancel}
        />
      </SC.Header>
      <SC.Content elevation={3}>
        <DataGrid
          sortingOrder={['desc', 'asc']}
          sortModel={sortModel}
          onSortModelChange={model => setSortModel(model)}
          rows={rows}
          columns={columns}
          // pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          // checkboxSelection
          // disableSelectionOnClick
          density="compact"
          onSelectionModelChange={handleSelectionChange}
          disableColumnFilter
          disableColumnMenu
          className={SC.DataGridClass}
          loading={isUpdating}
          onRowClick={openUserEdit}
        />
      </SC.Content>
    </SC.Container>
  );
});
